import { render } from "./Verification.vue?vue&type=template&id=a0504fb2&ts=true"
import script from "./Verification.vue?vue&type=script&lang=ts"
export * from "./Verification.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\wamp64\\www\\driver.total.cz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__